import React, { useState } from 'react'
import { Stepper } from 'react-form-stepper';
import './ServicesForm1.css'


function PersonalInfo({firstname, setfirstname, lastname, setlastname, email,  setemail, phone, setphone ,step , setstep}) {

    // const [firstname, setfirstname] = useState();
    // const [lastname, setlastname] = useState();
    // const [email, setemail] = useState();
    // const [phone, setphone] = useState();
    // const [services, setservices] = useState();
    // const [soletrader, setsoletrader] = useState();
    // const [privatedriver, setprivatedriver] = useState();
    // const [deliverydriver, setdeliverydriver] = useState();
    // const [cis, setcis] = useState();
    // const [taxidriver, settaxidriver] = useState();
    // const [onlineseller, setonlineseller] = useState();
    // const [other, setother] = useState();
    // const [propertyaccount, setpropertyaccount] = useState();
    // const [companyname, setcompanyname] = useState();
    // const [companynumber, setcompanynumber] = useState();
    // const [paye, setpaye] = useState();
    // const [message, setmessage] = useState();    
    // const [nextstep, setnextstep] = useState(1);



    const submithandle = (e) => {
        e.preventDefault()
        setstep(step + 1)
    }


    return (
        <div>
            <div className='stepper-div1'>
                {/* <Stepper activeStep={0} steps={[{ label: 'Personal Detail' }, { label: 'Services' }, { label: 'Complete' }]} styleConfig={{
                    activeBgColor: '#485CE1',
                    activeTextColor: '#fff',
                    inactiveBgColor: '#fff',
                    inactiveTextColor: '#3033B5',
                    completedBgColor: '#2729a1',
                    completedTextColor: '#fff',
                    size: '3em'
                    
                }} className={ 'stepper'}
            stepClassName={ 'stepper__step'}>
                </Stepper> */}

                <div className='stepper-main-div1'>
                    <div className='stepper-main-div2'> 
                    <div className='stepper-main-div3'>
                        <button className='stepper-main-btn1-active'><span>1</span></button>
                            <div className= 'stepper-main-div4'>
                                <span>Personal Detail</span>
                            </div>
                        </div>
                         </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1'><span>2</span></button>
                            <div className='stepper-main-div4'>
                                <span>Services</span>
                            </div>
                        </div>
                    </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1'><span>3</span></button>
                            <div className='stepper-main-div4'>
                                <span>Complete</span>
                            </div>
                        </div>
                    </div>
                </div>


                <form className="service-contact-form"  onSubmit={submithandle}>
                    <div class="row">
                        <div class="col-lg-6 col-12 ">
                            <label className='form-labels'>First Name<span>*</span></label>
                            <input
                                type="text"
                                name="firstname"
                                class="form-control contact-input-field5 d-none"
                                // value={firstname}
                                placeholder="First Name"
                                onChange={(e) => setfirstname(e.target.value)}
                                value={firstname}
                            />
                            <input
                                type="text"
                                name="firstname"
                                class="form-control contact-input-field5"
                                // value={firstname}
                                placeholder="First Name"
                                onChange={(e) => setfirstname(e.target.value)}
                                value={firstname}
                            />
                        </div>
                        <div class="col-lg-6 col-12 mt-4 mt-lg-0">
                            <label className='form-labels'>Last Name<span>*</span></label>
                            <input
                                type="text"
                                name="lastname"
                                class="form-control contact-input-field5"
                                placeholder="Last Name"
                                onChange={(e) => setlastname(e.target.value)}
                                value={lastname}

                            />
                        </div>
                        <div class="col-lg-6 col-12 mt-lg-5 mt-4">
                            <label className='form-labels'>Email Address<span>*</span></label>
                            <input
                                type="email"
                                name="email"
                                class="form-control contact-input-field5"
                                placeholder="E-Mail"
                                onChange={(e) => setemail(e.target.value)}
                                value={email}

                            />
                        </div>
                        <div class="col-lg-6 col-12 mt-lg-5 mt-4">
                            <label className='form-labels'>Phone Number<span>*</span></label>

                            <input
                                type="number"
                                name="phone"
                                class="form-control contact-input-field5"
                                placeholder="Phone Number"
                                onChange={(e) => setphone(e.target.value)}
                                value={phone}

                            />
                        </div>

                        <div className="col-12 mt-5 contact-us-btn-div2">
                            <button
                                type="submit"
                                className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default PersonalInfo
